export class ListViewItem {
  id: number;
  created_at: string | Date;
  name: string;
  price_cents: number;
  price_variations_count: number;
  sold_count: number;
  can_delete: boolean;
  uuids: string[];
  sku?: string;

  get price(): number {
    return this.price_cents / 100;
  }

  constructor(params: Partial<ListViewItem>) {
    Object.assign(this, params);
  }
}
